import locales from './locales'
export const localesDefault = locales

export const mainDefault = {
  languages: ['en']
}

export const stories = []

export const bots = {}

export const interests = []

export const categories = {}
